function DummyCache() {}

DummyCache.prototype.get = function () {
  return null;
};

DummyCache.prototype.has = function () {
  return false;
};

DummyCache.prototype.set = function () {
};

module.exports = DummyCache;



//////////////////
// WEBPACK FOOTER
// ./~/idtoken-verifier/src/helpers/dummy-cache.js
// module id = 527
// module chunks = 0